import React from "react";
import { FooterContainer, InnerBox } from "./elements";
import { Box } from "@mui/system";
import { FooterBody } from "../Typography/Typography";

const Footer: React.FC = () => {
    return (
        <FooterContainer>
            <InnerBox>
                <FooterBody>{`© Copyright ${new Date().getFullYear()} MoonVille`}</FooterBody>
                <Box sx={{
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: { xs: 'column', md: 'row' }
                }}>
                    <FooterBody>Privacy policy</FooterBody>
                    <FooterBody> Terms of use</FooterBody>
                </Box>
            </InnerBox>
        </FooterContainer >
    )
}

export default Footer